import { createApp } from "vue";
import PrimeVue from 'primevue/config';
import StayPrimevuePreset from "~/services/theme_presets";
import { createWebHistory, createRouter } from 'vue-router'

import Application from "~/controllers/home.vue"

// Views
import Main from "~/controllers/home/main.vue"
import SignUp from "~/controllers/home/sign_up.vue"

const routes = [
    { name: 'Main', path: '/', component: Main },
    { name: 'Sign Up', path: '/signup', component: SignUp, meta: {transition: "slide-left"} }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

const app = createApp(Application)
app.use(router)
app.use(PrimeVue, {
    theme: {
        preset: StayPrimevuePreset
    }
});

app.mount('#app')
